// import { ThemeOptions } from "@mui/material/styles";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import "./fontStyle.css";
import { itIT } from "@mui/material/locale";
import {
	teal,
	amber,
	cyan,
	orange,
	green,
	indigo,
	lightBlue,
	yellow,
	lime,
	deepOrange,
	lightGreen,
	grey,
} from "@mui/material/colors";
// import topbarbackground from "../../static/images/common/topbarbackground.png";

// const baseUrl = process.env.APP_NAME;
const isTestEnv: boolean = process.env.APP_NAME == "Gow_tst";

declare module "@mui/material/styles" {
	interface Theme {
		andonStatoPagamento: {
			inLavorazione: string;
			daRichiedere: string;
			inAttesaPagamento: string;
			parzialmentePagato: string;
			pagato: string;
			annullato: string;
		};
		coloriFiltro: {
			attivo: string;
			disattivo: string;
		};
	}
	// allow configuration using `createTheme`
	interface ThemeOptions {
		andonStatoPagamento?: {
			inLavorazione?: string;
			daRichiedere?: string;
			inAttesaPagamento?: string;
			parzialmentePagato?: string;

			pagato?: string;
			annullato?: string;
		};
		coloriFiltro?: {
			attivo?: string;
			disattivo?: string;
		};
	}
}

// export const themeOptions: ThemeOptions = {
export const theme = responsiveFontSizes(
	createTheme(
		{
			andonStatoPagamento: {
				inLavorazione: amber[300],
				daRichiedere: indigo[300],
				inAttesaPagamento: lime[300],
				parzialmentePagato: green[100],
				pagato: green[300],
				annullato: grey[300],
			},
			coloriFiltro: {
				// come definisco il colore yellow nella variante A200?

				attivo: lightGreen["A400"],
				// disattivo: teal[100],
			},
			palette: {
				// type: "light",
				primary: {
					main: "#00537f",
					dark: "#ff6f00",
				},
				secondary: {
					main: "#cdeeff",
				},
				text: {
					primary: "#191919",
					secondary: "#1d4763",
				},
				error: {
					main: "#FF2222",
				},
				info: {
					main: "#0289b0",
					// secondary: "#1d4763",
				},
				success: {
					main: "#69f0ae",
				},
				// divider: "rgba(121,85,72,0.2)",
				divider: "rgba(25,25,25,0.5)",
				background: {
					default: isTestEnv ? "#fa9898" : "#e0e0e0",
					paper: isTestEnv ? "#989812" : "#ffffff",
				},
			},
			typography: {
				fontFamily: "Roboto",
				h1: {
					fontFamily: "Rubik",
				},
				h2: {
					fontFamily: "Rubik",
				},
				h3: {
					fontFamily: "Rubik",
				},
				h4: {
					fontFamily: "Rubik",
				},
				h5: {
					fontFamily: "Rubik",
				},
				h6: {
					fontFamily: "Rubik",
				},
				subtitle1: {
					fontFamily: "Rubik",
				},
				subtitle2: {
					fontFamily: "Rubik",
				},
				overline: {
					fontFamily: "Rubik",
				},
			},
			spacing: 8,
			shape: {
				borderRadius: 4,
			},
			transitions: {
				duration: {
					shortest: 150,
					shorter: 200,
					short: 250,
					// most basic recommended timing
					standard: 300,
					// this is to be used in complex animations
					complex: 375,
					// recommended when something is entering screen
					enteringScreen: 225,
					// recommended when something is leaving screen
					leavingScreen: 195,
				},
				easing: {
					// This is the most common easing curve.
					easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
					// Objects enter the screen at full velocity from off-screen and
					// slowly decelerate to a resting point.
					easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
					// Objects leave the screen at full velocity. They do not decelerate when off-screen.
					easeIn: "cubic-bezier(0.4, 0, 1, 1)",
					// The sharp curve is used by objects that may return to the screen at any time.
					sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
				},
			},
			components: {
				MuiButton: {
					styleOverrides: {
						root: {
							// background: "linear-gradient(45deg, #90a4ae 30%, #607d8b 90%)",
							// border: 0,
							// borderRadius: 3,
							// boxShadow: "0 3px 5px 2px rgba(156, 39, 176, .3)",
							// color: "white",
							// height: 30,
							// padding: "0 30px",
							// marginLeft: 1,
							// marginRight: 1,
						},
					},
				},

				MuiAppBar: {
					styleOverrides: {
						root: {
							// background: `url(${topbarbackground})`,
							background: "linear-gradient(45deg, #00537f 30%, #00537fdd 90%)",
						},
					},
					defaultProps: {
						position: "sticky",
					},
				},
			},
		},
		itIT
	)
);
